import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Impressum = () => {
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <h1>Impressum</h1>
          <p>
            Das ist das Impressum von APresentMatch
           </p>
          <p>
            Jens Müller <br />
            Addresse: Hans-Thoma Str. 8, 69121 Heidelberg, Germany<br />
            Email: jm (at) creal (dot) de<br />
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Impressum;